import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Enlightenment_&_Revolutions_-_Age_of_Enlightenment.png';

function HistoryPageAgeOfEnlightenment() {
  return (
    <TopicPage
      topicKey="Age of Enlightenment"
      title="History: Age of Enlightenment"
      backgroundImage={bg}
      startRoute="/History-Age-of-Enlightenment-Go"
      scrollLabels={[
        "Philosophers and Ideas",
        "Reason and Science",
        "Legacy of Enlightenment"
      ]}
      backRoute="/history-age-of-revolutions"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageAgeOfEnlightenment;